// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_td-0";